export enum FillState {
  NONE,
  PARTFILLED,
  FILLED,
  REJECTED,
}

export namespace FillState {
  let elements = [FillState.NONE, FillState.PARTFILLED, FillState.FILLED, FillState.REJECTED];
  let alias = "com.bcdfx.model.FillState";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
